export const make = async (url) => {
  const resp = await fetch(`https://u.tft.tools/short-url/make`, {
    method: "POST",
    body: JSON.stringify({ url: url }),
    headers: {
      "Content-Type": "application/json",
    },
  });
  const json = await resp.json();
  return json.key;
};

export const resolve = async (key) => {
  const resp = await fetch(`https://u.tft.tools/short-url/resolve/${key}`);
  const json = await resp.json();
  return json.url;
};
